import { useState } from "react";

/**
 * Custom hook for managing modal visibility state
 *
 * @param initialState - Initial visibility state (default: false)
 * @returns Object with visibility state and control functions
 *
 * @example
 * const modal = useModal();
 *
 * <Button onClick={modal.open}>Open</Button>
 * <Modal open={modal.isOpen} onCancel={modal.close}>
 *   Content
 * </Modal>
 */
export function useModal(initialState = false) {
  const [isOpen, setIsOpen] = useState(initialState);

  return {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
    toggle: () => setIsOpen((prev) => !prev),
  };
}
